import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class FinalTaxesPostMortemPlanType extends Enum {
  key!: string;
  value!: string;

  static CONTINUE_OPERATING = {
    key: 'continue_operating',
    get value(): string {
      return Lang.t('tax.post-mortem-con-operating');
    }
  };

  static SELL_BUSINESS = {
    key: 'sell_business',
    get value(): string {
      return Lang.t('tax.post-mortem-sell-business');
    }
  };

  static WIND_UP_WITHIN_ONE_YEAR = {
    key: 'wind_up_within_one_year',
    get value(): string {
      return Lang.t('tax.post-mortem-wind-within-year');
    }
  };

  static WIND_UP_AFTER_ONE_YEAR = {
    key: 'wind_up_after_one_year',
    get value(): string {
      return Lang.t('tax.post-mortem-wind-after-year');
    }
  };
}
